export default {
    common: {
        title: 'Rediger billede',
        cancel: 'Annuller',
        save: 'Gem',
        crop: 'afgrøde',
        adjustments: 'Justeringer',
        filters: 'Filtre',
        frames: 'Rammer',
        overlays: 'Overlejringer',
        text: 'Tekst',
        stickers: 'Klistre­mærker',
        brush: 'Børste',
        ai: 'Opret billede ved hjælp af AI',
        reset: 'Nulstil',
        comingSoon: 'Kommer snart...',
        apply: 'Søg',
        undo: 'Borttag',
        redo: 'Redo',
        flipHorizontal: 'Vend horisontalt',
        flipVertical: 'Spejl Vertikalt',
        rotateClockwise: 'Drej med uret',
        rotateAntiClockwise: 'Drej mod uret',
        warning: 'Advarsel',
        discard: 'Bortkast',
        continue: 'Fortsæt redigering',
        discardHeading: 'Fjerne dine ændringer?',
        discardSubHeading: 'Hvis du lukker billedredigeringsprogrammet, vil dine ændringer ikke blive gemt',
        subtitle: 'De understøttede billedformater er PNG og JPEG',
        clone: 'Klon',
        delete: 'Slet',
    },
};
